import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RewardStatus } from '@core/enums/reward.enum';
import { EMPTY } from 'rxjs';
import { RewardsDataService } from '../../services/rewards-data.service';
import { RewardsHttpService } from '@core/services/rewards-http.service';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';

declare const $: any;

@Component({
  selector: 'kt-import-rewards',
  templateUrl: './import-rewards.component.html',
  styleUrls: ['./import-rewards.component.scss']
})
export class ImportRewardsDialogComponent implements OnInit {
  form: FormGroup;
  status = RewardStatus;
  buttonLoading = false;
  checkValidation = false;
  file: any;
  params = `?status=1&paginate=false`;
  rewardsDropdown = [];
  filterRewardsDropdown = [];
  rewardsDropdownSettings = {
    singleSelection: true,
    text: 'Please Select',
    enableFilterSelectAll: false,
    enableSearchFilter: true,
    classes: 'dropdown',
    primaryKey: 'id',
    labelKey: 'name',
    showCheckbox: false
  };

  dropdown = {
    campaign: this.dropdownHttpService.campaigns,
    currencies: this.dropdownHttpService.currencies,
  };
  showReadOnlyReward = false;
  selectedCampaign: any;
  campaignDropdownList = [];
  selectedRewards: string;

  @ViewChild('myFile') fileInput: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<ImportRewardsDialogComponent>,
    private rewardsDataService: RewardsDataService,
    private rewardsHttpService: RewardsHttpService,
    private translateService: TranslateService,
    private dropdownHttpService: DropdownHttpService,
    private eventEmitterService: EventEmitterService,
    private router: Router,
  ) { }

  async ngOnInit() {
    this.formInit();
  }

  onCloseDialog(event?: Event) {
    this.dialogRef.close();
  }

  onSave(event: any) {
    this.checkValidation = true;
    if (this.form.valid) {
      this.buttonLoading = true;
      const formData = new FormData();
      formData.append('attached_file', this.file);
      formData.append('promotion_id', this.form.value.promotion_id);
      formData.append('status', this.form.value.status);
      formData.append('currency_id', this.form.value.currency_id);
      if (this.form.value.campaign_id !== null) {
        formData.append('campaign_id', this.form.value.campaign_id);
      }

      if(this.form.value.status == 0 && (this.selectedRewards && this.selectedRewards.length > 0 && this.selectedRewards[0]['auto_approve'] == 0)){
        Swal.fire({
          title: this.translateService.instant('Are you sure?'),
          text: this.translateService.instant('Do you want to create this rewards as status Active'),
          icon: 'info',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          showCancelButton: true,
          confirmButtonText: this.translateService.instant('Yes'),
          cancelButtonText: this.translateService.instant('No'),
          reverseButtons: true
        }).then((resp) => {
          if(resp.dismiss === Swal.DismissReason.backdrop){
            this.buttonLoading = false;
            return;
          } else if(resp.dismiss == Swal.DismissReason.cancel){
            formData.append('status', '4');
            this.onImportReward(formData);
          } else if(resp.value){
            this.onImportReward(formData);
          }
        });
      } else{
        this.onImportReward(formData);
      }
    }
  }

  onFileUpload(event: any){
    const file: File = event.target.files[0];
    this.file = file;
    this.form.patchValue({attached_file: file});
  }

  onSelectedCampaignChanged(event:any){

    if(this.campaignDropdownList === undefined){
      this.getDropdownCampaign();
    }

    const campaignId = this.form.get('campaign_id').value;

    if(campaignId === null){
      this.showReadOnlyReward = false;
      if(this.selectedRewards && this.selectedRewards.length > 0){
        this.form.get('promotion_id').setValue(+this.selectedRewards[0]['id']);
      } else{
        this.form.get('promotion_id').setValue(null);
      }
      return;
    }

    this.selectedCampaign = this.campaignDropdownList.find((item) => {
      return item.id === campaignId;
    });

    if(this.selectedCampaign !== undefined){
      const rewardData = this.rewardsDropdown.find((reward) => {
                          return reward.code === this.selectedCampaign.promotion_code;
                        });

      if(rewardData !== undefined){
        this.form.get('promotion_id').setValue(+rewardData.id);
        this.showReadOnlyReward = true;
      }
      else{
        this.showReadOnlyReward = false;
        //exclude free credit(register) type promotion for campaign (promo_type- 3: free credit, promo_sub_type- 5: register)
        this.filterRewardsDropdown = this.rewardsDropdown.filter(x => !(x.promo_type == 3 && x.promo_sub_type == 5));
        if(this.selectedRewards && this.selectedRewards.length > 0){
          this.form.get('promotion_id').setValue(+this.selectedRewards[0]['id']);
        } else{
          this.form.get('promotion_id').setValue(null);
        }
      }
    }
  }

  onSelectedItemChange(item) {
    this.selectedRewards = item;
  }

  async onChangeCurrency(currency_id:number){
    this.form.patchValue({
      promotion_id: null,
      status: null,
      campaign_id: null,
    });
    this.showReadOnlyReward = false;
    this.selectedRewards = null;
    const res = await this.rewardsHttpService.getRewardsList(this.params+'&currency_id='+currency_id).toPromise();
    this.rewardsDropdown = res;
    this.rewardsDropdown.map(function (elm) {
      elm['name'] = elm.code + ' - ' + elm.name;
    });
    this.filterRewardsDropdown = this.rewardsDropdown;
    await this.getDropdownCampaign();
    if (this.campaignDropdownList.length > 0) {
      this.campaignDropdownList = this.campaignDropdownList.filter(x => x.currency_id == currency_id);
    }
  }

  onImportReward(formData: any){
    this.rewardsDataService.import(formData).pipe(
      tap((res: any) => {
        this.buttonLoading = false;
        // Pass import_id back so the parent page can poll for completion (CR3).
        // Falls back to `true` for legacy sync responses (triggers list refresh).
        this.dialogRef.close(res?.import_id ?? true);
        const message = Array.isArray(res?.message) && res.message.length > 0
          ? res.message[0]
          : this.translateService.instant('Import has been queued. You can track its result in Import History.');
        Swal.fire({
          title: this.translateService.instant('System Message'),
          text: message,
          icon: 'info',
          heightAuto: false,
        });
      }),
      catchError((error) => {
        const body = error?.error;

        if (error?.status === 409) {
          const messages = body?.message;
          const baseMessage = Array.isArray(messages) && messages.length > 0
            ? messages.join(' ')
            : this.translateService.instant("There's a file already being imported. Please check Import History for the current status.");
          this.buttonLoading = false;
          this.file = null;
          this.form.patchValue({attached_file: null});
          this.fileInput.nativeElement.value = '';
          Swal.fire({
            title: this.translateService.instant('System Message'),
            text: baseMessage,
            icon: 'warning',
            heightAuto: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.translateService.instant('Yes, View Progress'),
            cancelButtonText: this.translateService.instant('No, Cancel'),
            reverseButtons: true,
          }).then(result => {
            if (result.value) {
              this.dialogRef.close();
              this.router.navigate(['/import-history']);
            }
          });
          return EMPTY;
        }

        // All other errors
        this.buttonLoading = false;
        this.file = null;
        this.form.patchValue({attached_file: null});
        this.fileInput.nativeElement.value = '';

        const messages: string[] = Array.isArray(body?.message) ? body.message
          : body?.message ? [body.message]
          : [this.translateService.instant('Import failed. Please try again.')];
        const html = '<ul style="text-align:left;">' + messages.map(m => `<li>${m}</li>`).join('') + '</ul>';
        Swal.fire({
          title: this.translateService.instant('System Message'),
          html,
          icon: 'error',
          heightAuto: false,
        });

        throw error;
      })
    ).subscribe();
  }

  private async getDropdownCampaign() {
    return new Promise<void>((resolve) => {
      this.dropdown.campaign.subscribe((data) => {
        this.campaignDropdownList = data;
        resolve();
      });
    });
  }

  private formInit() {
    this.form = new FormGroup({
      promotion_id: new FormControl(null, [Validators.required]),
      status: new FormControl(null, [Validators.required]),
      attached_file: new FormControl(null, [Validators.required]),
      campaign_id: new FormControl(null),
      currency_id: new FormControl(null, [Validators.required]),
    });
  }

}
